<template>
  <div class="dropship-capacity-indicator-container">
    <div v-if="isAddButton">
      <div
        ref="config_tooltip"
        v-tippy="containerConfigTippyConfig"
        class="dropship-capacity-indicator dropship-capacity-indicator--add text-sm text-secondary"
        qaid="dropshipIndicatorAddButton"
        @mouseup.prevent="$emit('add-container')"
        @hidden="onConfigHidden"
      >
        {{ bp('containerAdd') }}
        <i class="material-icons md-18 ml-25">add_circle_outline</i>
      </div>

      <!-- Container configuration tooltip -->
      <div v-if="showTooltipConfig" id="container-config-tooltip" v-tippy-html qaid="containerConfigTooltip">
        <ContainerConfiguration
          ref="containerConfiguration"
          class="m-2"
          :base-properties="baseProperties"
          :containers="containers"
          @close="closeTooltip"
        />
      </div>
    </div>
    <div v-else-if="isLimitWarning">
      <div class="dropship-capacity-indicator dropship-capacity-indicator--max text-xs align-middle">
        {{ bp('containerMax') }}
      </div>
    </div>
    <div v-else class="relative">
      <div class="dropship-capacity-indicator" :class="containerClass">
        <div v-for="index in 5" :key="index" class="dropship-bar" :class="dropshipBarClass(index)"></div>
      </div>
      <div v-if="containerLabel" class="text-secondary text-left mt-1">
        <div v-html="containerLabel"></div>
      </div>
      <div v-if="displayDeleteButton">
        <trek-button
          text
          icon-only
          icon-alert
          icon="cancel"
          class="dropship-capacity-indicator-container--remove-container"
          qaid="dropshipCapacity.removeButton"
          aria-label="Delete container"
          @click="setContainerToDelete(containerSize)"
        >
        </trek-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapMutations} from 'vuex';
import TrekButton from '@/components/TrekButton';
import ContainerConfiguration from '@/components/containers/drop-ship/ContainerConfiguration';

export default {
  name: 'ContainerIndicator',

  components: {TrekButton, ContainerConfiguration},

  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    container: {
      type: Object,
      default: () => {},
    },
    containers: {
      type: Object,
      default: () => {},
    },
    isAddButton: Boolean,
    isLimitWarning: Boolean,
    showTooltipConfig: Boolean,
    showDeleteButton: Boolean,
  },

  data() {
    return {
      dialogVisible: false,
      containerConfigTippyConfig: {
        html: '#container-config-tooltip',
        theme: 'light',
        trigger: 'click',
        reactive: true,
        interactive: true,
      },
    };
  },

  computed: {
    fillPercentage() {
      if (this.container && this.container.volumePercentage) return parseInt(this.container.volumePercentage);
      return null;
    },

    containerClass() {
      if (this.fillPercentage === 100) return 'dropship-capacity-indicator--full';
      else if (this.fillPercentage > 0) return ' dropship-capacity-indicator--partial';
      return null;
    },

    containerLabel() {
      if (this.container && this.container.id && typeof this.container.id === 'string') {
        if (this.container.id.startsWith('DSCont_20ft')) return this.bp('container20');
        if (this.container.id.startsWith('DSCont_40ft')) return this.bp('container40');
        if (this.container.id.startsWith('DSCont_40Hift')) return this.bp('container40HC');
      }
      return null;
    },

    containerSize() {
      if (this.container && this.container.id && typeof this.container.id === 'string') {
        if (this.container.id.startsWith('DSCont_20ft')) return '20';
        if (this.container.id.startsWith('DSCont_40ft')) return '40';
        if (this.container.id.startsWith('DSCont_40Hift')) return '40HC';
      }
      return null;
    },

    displayDeleteButton() {
      let containerCount = 0;

      if (this.containers && this.containers.totalContainers)
        containerCount = parseInt(this.containers.totalContainers);

      return this.showDeleteButton && this.fillPercentage === 0 && containerCount > 1;
    },
  },

  methods: {
    dropshipBarClass(index) {
      // If container is empty return nothing (default is empty styling)
      if (this.fillPercentage === 0) return '';

      // If container is full then return full styling
      if (this.fillPercentage === 100) return 'dropship-bar--full';

      // If we're anywhere between 1 and 40 percent then the first bar
      // is partial styling. The middle bars fill when the percentage threshold is met.
      // The last bar will never be partial. It simply fills to 'full' styling when the fill
      // is at 100%
      if (
        (index === 1 && this.fillPercentage > 0) ||
        (index === 2 && this.fillPercentage >= 40) ||
        (index === 3 && this.fillPercentage >= 60) ||
        (index === 4 && this.fillPercentage >= 80)
      )
        return 'dropship-bar--partial';
    },

    closeTooltip() {
      let el = this.$refs['config_tooltip'];

      if (el && el._tippy) {
        el._tippy.hide();
      }
    },

    onConfigHidden() {
      if (this.$refs.containerConfiguration) this.$refs.containerConfiguration.resetState();
    },

    ...mapMutations('backend', ['setContainerToDelete']),
  },
};
</script>
